import { useState } from 'react';
import { Link } from 'react-router-dom';

interface ShopListProps {
  selectedShop: number | null;
  onShopSelect: (id: number | null) => void;
}

export default function ShopList({ selectedShop, onShopSelect }: ShopListProps) {
  const shops = [
    {
      id: 'daum-nail-salon',
      name: '다움네일살롱',
      location: '강남구 청담동',
      address: '서울 강남구 청담동 123-45',
      category: '네일',
      isPartner: true,
      rating: 4.9,
      reviewCount: 328,
      distance: '0.5km',
      image: 'https://public.readdy.ai/ai/img_res/252e34dcaa166cd95bdb022e0785cacf.jpg',
      specialty: '프렌치네일 디자인으로 유명한 프리미엄 샵',
      reviews: [
        { author: '김민지', rating: 5, date: '2024.01.15', content: '네일 디자인이 정말 섬세하고 예뻐요! 직원분들도 친절하시고 샵 분위기도 고급스러워서 너무 만족스러웠습니다. 다음에도 꼭 재방문할게요 💅✨', images: 2 },
        { author: '이서연', rating: 5, date: '2024.01.10', content: '청담동에서 제일 잘하는 네일샵인 것 같아요. 원하는 디자인 정확하게 구현해주시고 지속력도 좋아요!', images: 3 },
        { author: '박지은', rating: 4.5, date: '2024.01.05', content: '가격대는 있지만 그만큼 퀄리티가 확실해요. 예약이 빨리 차니 미리미리 예약하세요~', images: 1 }
      ]
    },
    {
      id: 'lavender-lash',
      name: '라벤더 아이래쉬',
      location: '마포구 홍대입구',
      address: '서울 마포구 서교동 456-78',
      category: '속눈썹',
      isPartner: true,
      rating: 4.8,
      reviewCount: 256,
      distance: '1.2km',
      image: 'https://readdy.ai/api/search-image?query=Modern%20eyelash%20extension%20salon%20with%20soft%20lavender%20and%20white%20tones%2C%20comfortable%20treatment%20bed%2C%20professional%20lighting%2C%20minimalist%20beauty%20studio%2C%20elegant%20feminine%20design%2C%20premium%20lash%20service%20space%2C%20serene%20atmosphere%2C%20clean%20aesthetic&width=400&height=300&seq=shop-detail-lash-1&orientation=landscape',
      specialty: '자연스러운 속눈썹 연장 전문',
      reviews: [
        { author: '최유진', rating: 5, date: '2024.01.18', content: '속눈썹 연장 처음 해봤는데 너무 자연스럽고 예뻐요! 원장님이 눈 모양에 맞춰서 디자인 추천해주셔서 정말 만족스러워요 😍', images: 2 },
        { author: '정수아', rating: 5, date: '2024.01.12', content: '홍대에서 래쉬 맛집 찾았어요! 지속력 좋고 빠짐도 거의 없어요. 가격도 합리적이에요~', images: 1 },
        { author: '강혜린', rating: 4.5, date: '2024.01.08', content: '시술 중에 전혀 아프지 않고 편안했어요. 결과물도 너무 마음에 들어요!', images: 0 }
      ]
    },
    {
      id: 'rose-skincare',
      name: '로즈 스킨케어',
      location: '강남구 압구정동',
      address: '서울 강남구 압구정로 789-12',
      category: '피부관리',
      isPartner: true,
      rating: 5.0,
      reviewCount: 412,
      distance: '0.8km',
      image: 'https://readdy.ai/api/search-image?query=Premium%20skincare%20spa%20room%20with%20rose%20gold%20accents%2C%20soft%20pink%20lighting%2C%20luxury%20facial%20treatment%20bed%2C%20elegant%20minimalist%20interior%2C%20professional%20beauty%20clinic%2C%20warm%20beige%20tones%2C%20sophisticated%20wellness%20space%2C%20serene%20healing%20atmosphere&width=400&height=300&seq=shop-detail-skin-1&orientation=landscape',
      specialty: '맞춤형 피부관리와 힐링 케어',
      reviews: [
        { author: '윤서현', rating: 5, date: '2024.01.20', content: '피부 상태 체크부터 관리까지 정말 꼼꼼하게 해주세요. 관리 받고 나면 피부가 한 톤 밝아지는 느낌이에요! 압구정 최고 피부관리샵 👍', images: 1 },
        { author: '한지우', rating: 5, date: '2024.01.16', content: '원장님이 피부과 출신이셔서 전문적이고 믿음이 가요. 트러블 피부였는데 많이 좋아졌어요!', images: 2 },
        { author: '임나연', rating: 5, date: '2024.01.11', content: '샵 분위기도 너무 좋고 관리 실력도 최고예요. 힐링되는 시간이었어요 💆‍♀️', images: 0 }
      ]
    },
    {
      id: 'bloom-waxing',
      name: '블룸 왁싱 스튜디오',
      location: '강남구 신사동',
      address: '서울 강남구 신사동 321-54',
      category: '왁싱',
      isPartner: true,
      rating: 4.9,
      reviewCount: 189,
      distance: '1.5km',
      image: 'https://readdy.ai/api/search-image?query=Private%20waxing%20studio%20with%20soft%20pastel%20colors%2C%20clean%20modern%20design%2C%20comfortable%20treatment%20room%2C%20professional%20beauty%20space%2C%20minimalist%20aesthetic%2C%20warm%20lighting%2C%20elegant%20feminine%20interior%2C%20premium%20personal%20care%20salon&width=400&height=300&seq=shop-detail-wax-1&orientation=landscape',
      specialty: '프라이빗한 공간에서 편안한 왁싱',
      reviews: [
        { author: '송민아', rating: 5, date: '2024.01.19', content: '왁싱이 처음이라 긴장했는데 원장님이 너무 친절하게 설명해주시고 배려해주셔서 편안하게 받았어요. 완전 프라이빗해서 좋아요!', images: 0 },
        { author: '오지혜', rating: 5, date: '2024.01.14', content: '신사동에서 왁싱 맛집이에요! 아프지 않게 잘 해주시고 사후관리 팁도 자세히 알려주세요~', images: 1 },
        { author: '배수진', rating: 4.5, date: '2024.01.09', content: '깨끗하고 위생적이에요. 예약제라 대기 없이 바로 받을 수 있어서 좋아요!', images: 0 }
      ]
    },
    {
      id: 'petal-hair',
      name: '페탈 헤어살롱',
      location: '강남구 청담동',
      address: '서울 강남구 청담동 654-32',
      category: '헤어',
      isPartner: true,
      rating: 4.8,
      reviewCount: 294,
      distance: '0.6km',
      image: 'https://readdy.ai/api/search-image?query=Chic%20hair%20salon%20with%20pastel%20pink%20and%20beige%20interior%2C%20modern%20styling%20stations%2C%20elegant%20mirrors%2C%20professional%20beauty%20space%2C%20sophisticated%20feminine%20design%2C%20soft%20ambient%20lighting%2C%20premium%20hairdressing%20studio%2C%20minimalist%20aesthetic&width=400&height=300&seq=shop-detail-hair-1&orientation=landscape',
      specialty: '트렌디한 컷과 컬러 전문',
      reviews: [
        { author: '신예린', rating: 5, date: '2024.01.17', content: '디자이너님이 트렌드를 정말 잘 아시고 제 얼굴형에 딱 맞는 스타일 추천해주셨어요! 염색 색감도 너무 예뻐요 💇‍♀️✨', images: 3 },
        { author: '조아영', rating: 5, date: '2024.01.13', content: '청담동 헤어샵 중에 가성비 최고인 것 같아요. 실력도 좋고 가격도 합리적이에요!', images: 2 },
        { author: '홍다은', rating: 4.5, date: '2024.01.07', content: '컷트 라인이 정말 깔끔하고 예뻐요. 스타일 유지도 오래가요~', images: 1 }
      ]
    },
    {
      id: 'aurora-makeup',
      name: '오로라 메이크업',
      location: '강남구 가로수길',
      address: '서울 강남구 신사동 987-65',
      category: '메이크업',
      isPartner: true,
      rating: 5.0,
      reviewCount: 167,
      distance: '1.0km',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20makeup%20studio%20with%20soft%20lighting%2C%20professional%20vanity%20mirror%2C%20pastel%20pink%20and%20gold%20accents%2C%20luxury%20cosmetics%20display%2C%20sophisticated%20beauty%20space%2C%20feminine%20minimalist%20design%2C%20premium%20bridal%20makeup%20room%2C%20warm%20atmosphere&width=400&height=300&seq=shop-detail-makeup-1&orientation=landscape',
      specialty: '웨딩 및 특별한 날 메이크업',
      reviews: [
        { author: '김채원', rating: 5, date: '2024.01.21', content: '결혼식 메이크업 받았는데 정말 완벽했어요! 사진 찍을 때도 너무 예쁘게 나왔고 하루 종일 무너지지 않았어요 👰💕', images: 4 },
        { author: '이다인', rating: 5, date: '2024.01.15', content: '원장님이 메이크업 아티스트 출신이셔서 실력이 정말 뛰어나세요. 웨딩 메이크업 여기서 꼭 받으세요!', images: 3 },
        { author: '박서윤', rating: 5, date: '2024.01.10', content: '특별한 날 메이크업 맡기기 딱 좋은 곳이에요. 상담도 꼼꼼하게 해주시고 결과물도 최고예요!', images: 2 }
      ]
    }
  ];

  const partnerShops = shops.filter(shop => shop.isPartner);

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl font-medium text-gray-800 mb-2">근처 추천 제휴 뷰티샵</h2>
          <p className="text-sm text-gray-600">다움과 함께하는 프리미엄 뷰티샵을 만나보세요</p>
        </div>
        <div className="flex items-center space-x-3">
          <button className="px-4 py-2 bg-white border-2 border-gray-200 text-gray-700 text-sm font-medium rounded-full hover:border-rose-400 hover:text-rose-400 transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-filter-3-line mr-2"></i>
            필터
          </button>
          <button className="px-4 py-2 bg-white border-2 border-gray-200 text-gray-700 text-sm font-medium rounded-full hover:border-rose-400 hover:text-rose-400 transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-sort-desc mr-2"></i>
            정렬
          </button>
        </div>
      </div>

      <div className="space-y-6">
        {partnerShops.map((shop) => (
          <Link
            key={shop.id}
            to={`/shop/${shop.id}`}
            className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col md:flex-row group cursor-pointer"
          >
            <div className="w-full md:w-80 h-64 md:h-auto overflow-hidden flex-shrink-0">
              <img
                alt={shop.name}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                src={shop.image}
              />
            </div>
            <div className="flex-1 p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-pink-600 transition-colors">
                    {shop.name}
                  </h3>
                  <div className="flex items-center gap-4 text-sm text-gray-600">
                    <span className="px-3 py-1 bg-pink-100 text-pink-600 rounded-full font-medium">
                      {shop.category}
                    </span>
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-yellow-400"></i>
                      <span className="font-semibold text-gray-900">{shop.rating}</span>
                      <span>({shop.reviewCount})</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <i className="ri-map-pin-line text-pink-500"></i>
                      <span>{shop.distance}</span>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-gray-700 mb-4 line-clamp-2">{shop.specialty}</p>
              <div className="flex flex-wrap gap-2 mb-4">
                {shop.reviews.slice(0, 2).map((review, index) => (
                  <div
                    key={index}
                    className="bg-gray-50 rounded-2xl p-4"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center">
                          <span className="text-white text-xs font-medium">{review.author[0]}</span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-800">{review.author}</p>
                          <div className="flex items-center space-x-2">
                            <div className="flex items-center">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <i
                                  key={star}
                                  className={`ri-star-${star <= Math.floor(review.rating) ? 'fill' : star - 0.5 <= review.rating ? 'half-fill' : 'line'} text-yellow-400 text-xs`}
                                ></i>
                              ))}
                            </div>
                            <span className="text-xs text-gray-500">{review.date}</span>
                          </div>
                        </div>
                      </div>
                      {review.images > 0 && (
                        <div className="flex items-center space-x-1 text-xs text-gray-500">
                          <i className="ri-image-line"></i>
                          <span>{review.images}</span>
                        </div>
                      )}
                    </div>
                    <p className="text-sm text-gray-700 leading-relaxed">{review.content}</p>
                  </div>
                ))}
              </div>
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div className="flex items-center gap-6 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-heart-line text-rose-400 text-xl"></i>
                    <span className="text-sm font-medium text-gray-800">찜하기</span>
                  </div>
                </div>
                <span className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-semibold group-hover:shadow-lg transition-all whitespace-nowrap">
                  상세보기
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-12">
        <button className="px-8 py-3 border-2 border-rose-400 text-rose-400 text-sm font-medium rounded-full hover:bg-rose-400 hover:text-white transition-all whitespace-nowrap cursor-pointer">
          <i className="ri-refresh-line mr-2"></i>
          더 많은 뷰티샵 보기
        </button>
      </div>
    </div>
  );
}
